import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { organizationHttp } from "./organization-http";

export const organizationCacheKeys = {
  organization: "organization",
};

export const useGetOrganization = (
  organizationKeyName?: OrganizationKeyName
) => {
  return useQuery(
    [organizationCacheKeys.organization, organizationKeyName],
    () => organizationHttp.getOrganization(organizationKeyName),
    { refetchOnWindowFocus: false, enabled: !!organizationKeyName }
  );
};

export const useUpdateOrganization = (keyname?: string) => {
  const queryClient = useQueryClient();

  return useMutation(organizationHttp.updateOrganization, {
    onSuccess: async () => {
      if (keyname) {
        await queryClient.refetchQueries([
          organizationCacheKeys.organization,
          keyname,
        ]);
      }
    },
  });
};

export const useUploadOrganizationReceiptImage = (keyName?: string) => {
  const queryClient = useQueryClient();
  return useMutation(organizationHttp.uploadOrganizationReceiptImage, {
    onSuccess: async () => {
      if (keyName) {
        await queryClient.refetchQueries([
          organizationCacheKeys.organization,
          keyName,
        ]);
      }
    },
  });
};
